/* eslint-disable jsx-a11y/anchor-is-valid, jsx-a11y/no-static-element-interactions,
jsx-a11y/click-events-have-key-events, jsx-a11y/anchor-has-content */
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import PropTypes from "prop-types";
import TopbarNav from "../topbar_investor/topbar_nav/TopbarNav";
import TopbarProfile from "../topbar_investor/TopbarProfile";
import InvestorSidebarSwipeable from "../topbar_investor/sidebar_mobile/SidebarSwipeable";
import { getUserPortfolio } from "../../../shared/services/apiGateway";
import "../../../shared/style/investorTopbar.css";

const PlanningTopbar = ({ user }) => {
  const [userPortfolio, setUserPortfolio] = useState({});
  const [hasLoadedPortfolio, setHasLoadedPortfolio] = useState(false);
  const isMobile = useMediaQuery("(max-width:991px)");

  useEffect(() => {
    const abortController = new AbortController();
    let ignore = false;

    async function fetchData() {
      setUserPortfolio({});
      setHasLoadedPortfolio(false);
      try {
        const portfolio = await getUserPortfolio(true, false, false, abortController.signal);
        if (!ignore && portfolio !== "aborted" && portfolio.data) {
          setUserPortfolio(portfolio.data);
          setHasLoadedPortfolio(true);
        }
      } catch (error) {
        if (!ignore && error.statusCode === 404) {
          setHasLoadedPortfolio(true);
          return;
        }
        throw error;
      }
    }

    if (user) {
      fetchData();
    } else {
      setUserPortfolio({});
      setHasLoadedPortfolio(false);
    }

    return () => {
      ignore = true;
      abortController.abort();
    };
  }, [user]);

  return (
    <div
      className="topbar topbar--navigation investor-topbar"
      style={{ position: "relative", zIndex: 1400 }}
    >
      <Helmet>
        <title>Alumni Ventures</title>
        <link
          rel="shortcut icon"
          href={`${process.env.AVG_API_PATH}/favicon.ico`}
          sizes="16x16"
        />
      </Helmet>
      <div className="topbar__wrapper">
        <div className="topbar__left">
          {isMobile && user && (
            <InvestorSidebarSwipeable
              user={user}
              userPortfolio={userPortfolio}
              hasLoadedPortfolio={hasLoadedPortfolio}
            />
          )}
          <a
            style={{
              marginLeft: "15px",
              marginTop: "10px",
              marginRight: "15px",
              display: "block",
              cursor: "pointer",
            }}
            className="topbar__logo"
            onClick={() => window.location.replace(`${process.env.AVG_API_PATH}/`)}
          />
        </div>
        {user != null && (
          <div className="investor-topbar__center-nav">
            <TopbarNav
              user={user}
              userPortfolio={userPortfolio}
              hasLoadedPortfolio={hasLoadedPortfolio}
            />
          </div>
        )}
        <div className="topbar__right">
          {user != null && (
            <TopbarProfile user={user} />
          )}
        </div>
      </div>
    </div>
  );
};

PlanningTopbar.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  user: PropTypes.object,
};

PlanningTopbar.defaultProps = {
  user: null,
};

function mapStateToProps(state) {
  const { auth } = state;
  const { user } = auth;
  return { user };
}

export default connect(mapStateToProps)(PlanningTopbar);
